import {
  getCollaborationArtifact,
  getCollaborationArtifacts,
  getCollaborationWorkspace,
  getCollaborationWorkspaces
} from "common/apiV2";

export const fetchWorkspaces = async () => {
  const { data } = await getCollaborationWorkspaces();
  return data;
};

export const fetchWorkspace = async slug => {
  const { data } = await getCollaborationWorkspace(slug);
  return data;
};

export const fetchArtifacts = async slug => {
  const { data } = await getCollaborationArtifacts(slug);
  return data;
};

export const fetchArtifact = async (slug, key) => {
  const { data } = await getCollaborationArtifact(slug, key);
  return data;
};
